/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';

import './input-suggest.scss';

import { useOnClickOutside } from '../hooks';

export interface InputSuggestProps {
	placeholder?: string;
	value?: any;
	onChange?: (value: any) => void;
	withNull?: boolean;
	stringify?: (value: any) => string | null;
	onSearch: (value: string) => Promise<any[]>;
	error?: string | null;
}

export const InputSuggest: React.FC<InputSuggestProps> = ({
	placeholder,
	value,
	onChange,
	withNull,
	stringify = val => String(val),
	onSearch,
	error,
}) => {
	const mref = useRef<HTMLDivElement>(null);
	const [idle, setIdle] = React.useState<any>(null);
	const [edit, setEdit] = useState<string | null>(null);
	const [active, setActive] = useState<boolean>(false);
	const [children, setChildren] = useState<any[]>([]);

	useEffect(() => {
		setEdit(stringify(value) ?? placeholder ?? 'Наинайте вводить');
		setChildren([]);
	}, [placeholder, stringify, value]);

	useOnClickOutside(mref, () => {
		setActive(false);
		setEdit(stringify(value) ?? placeholder ?? 'Наинайте вводить');
	});

	const handleActive = (event: React.MouseEvent) => {
		event.stopPropagation();
		setEdit('');
		setActive(true);
		if (idle) clearTimeout(idle);
		setIdle(setTimeout(() => handleSearch(''), 500));
	};

	const handleChange = (event: React.MouseEvent, val: string | null) => {
		event.stopPropagation();
		setActive(false);
		setEdit(stringify(val) ?? placeholder ?? 'Наинайте вводить');
		if (onChange) {
			onChange(val);
			setEdit(stringify(value) ?? placeholder ?? 'Наинайте вводить');
		}
	};

	const handleSearch = async (val: string) => {
		const foun = await onSearch(val);
		const vals = withNull ? [null, ...foun] : foun;
		setChildren(vals);
	};

	const handleChangeText = (event: React.FormEvent<HTMLDivElement>) => {
		if (idle) clearTimeout(idle);
		// Все работает не вые!
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-expect-error
		setIdle(setTimeout(() => handleSearch(event?.target?.innerText ?? ''), 500));
	};

	return (
		<div
			ref={mref}
			className={`input-suggest inputcomponent js-input-suggest ${error ? 'error' : ''}`}
			onClick={handleActive}
			title={placeholder}
		>
			{value && <span className="input-suggest__title">{placeholder ?? 'Наинайте вводить'}</span>}
			<div
				contentEditable
				suppressContentEditableWarning={true}
				className={`suggest-selected single-line ${active ? 'suggest-arrow-active' : ''}`}
				onInput={handleChangeText}
			>
				{edit ?? placeholder}
			</div>
			{active && (
				<div className="suggest-items">
					{children.map((itm, index) => (
						<div key={index} onClick={event => handleChange(event, itm)}>
							{itm ? stringify(itm) : 'Не выбрано'}
						</div>
					))}
				</div>
			)}
			{error && <div className="error">{error}</div>}
		</div>
	);
};
